// import React from 'react';
// import { Link } from 'react-router-dom';
// import { LineChart, ArrowLeft, Lock } from 'lucide-react';
// import { APP_NAME } from '../constants/appConstants';

// const AuthLayout = ({ leftPanelContent, children }) => {
//   return (
//     <div className="min-h-screen flex">
//       {/* Left Panel - 25% */}
//       <div className="hidden md:flex md:w-1/4 bg-gradient-to-br from-blue-600 to-indigo-700 relative overflow-hidden">
//         {/* Background pattern */}
//         <div className="absolute inset-0 opacity-10">
//           <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
//             <defs>
//               <pattern id="grid" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse">
//                 <path d="M0,5 L10,5 M5,0 L5,10" stroke="white" strokeWidth="0.5" fill="none" />
//               </pattern>
//             </defs>
//             <rect width="100" height="100" fill="url(#grid)" />
//           </svg>
//         </div>

//         {/* Content */}
//         <div className="relative z-10 flex flex-col px-6 py-8 w-full">
//           {/* Logo */}
//           <Link to="/" className="flex items-center space-x-2 mb-10">
//             <div className="h-9 w-9 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
//               <LineChart className="text-white h-5 w-5" />
//             </div>
//             <span className="text-lg font-bold text-white">{APP_NAME}</span>
//           </Link>

//           {/* Main content area */}
//           <div className="flex-1 flex items-center">
//             <div className="text-white w-full">
//               {leftPanelContent}
//             </div>
//           </div>

//           {/* Security notice at bottom */}
//           <div className="mt-auto pt-6">
//             <div className="flex items-start text-xs text-blue-100">
//               <Lock className="h-3.5 w-3.5 mr-2 flex-shrink-0 mt-0.5" />
//               <span>{APP_NAME} secures your data with enterprise-grade encryption</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Right Panel - 75% */}
//       <div className="flex-1 flex flex-col bg-white md:w-3/4">
//         {/* Back button */}
//         <div className="px-6 py-4">
//           <Link 
//             to="/" 
//             className="inline-flex items-center text-sm text-gray-600 hover:text-blue-600 transition-colors"
//           >
//             <ArrowLeft className="h-4 w-4 mr-1.5" />
//             Back to home
//           </Link>
//         </div>

//         {/* Form content - centered vertically and horizontally */}
//         <div className="flex-1 flex items-center justify-center px-6 pb-8">
//           <div className="w-full max-w-5xl">
//             {children}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AuthLayout;











import React from 'react';
import { Link } from 'react-router-dom';
import { LineChart, ArrowLeft, Lock } from 'lucide-react';
import { APP_NAME, LOGO_ICON } from '../constants/appConstants';

const AuthLayout = ({ leftPanelContent, children, isLoginPage = false, backgroundImage }) => {
  const leftPanelWidth = isLoginPage ? 'md:w-2/4' : 'md:w-1/4';
  const rightPanelWidth = isLoginPage ? 'md:w-2/4' : 'md:w-3/4';

  return (
    <div className="min-h-screen flex">
      {/* Left Panel */}
      <div className={`hidden md:flex ${leftPanelWidth} bg-gradient-to-br from-primary-600 to-primary-700 relative overflow-hidden`}>
        {/* Background Image (for login page) */}
        {isLoginPage && backgroundImage && (
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${backgroundImage})` }}
          />
        )}
        
        {/* Overlay */}
        <div className={`absolute inset-0 ${isLoginPage ? 'bg-gradient-to-b from-primary-600/90 to-primary-700/70' : 'opacity-10'}`}>
          {!isLoginPage && (
            <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
              <defs>
                <pattern id="grid" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse">
                  <path d="M0,5 L10,5 M5,0 L5,10" stroke="white" strokeWidth="0.5" fill="none" />
                </pattern>
              </defs>
              <rect width="100" height="100" fill="url(#grid)" />
            </svg>
          )}
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col px-6 py-8 w-full">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 mb-10">
            <div className="h-9 w-9 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
              <img src={LOGO_ICON} alt={`${APP_NAME} Logo`} className="h-7 w-7 object-contain" />
            </div>
            <span className="text-lg font-bold text-white">{APP_NAME}</span>
          </Link>

          {/* Main content area */}
          <div className="flex-1 flex items-center">
            <div className="text-white w-full">
              {leftPanelContent}
            </div>
          </div>

          {/* Security notice at bottom */}
          <div className="mt-auto pt-6">
            <div className="flex items-start text-xs text-primary-100">
              <Lock className="h-3.5 w-3.5 mr-2 flex-shrink-0 mt-0.5" />
              <span>{APP_NAME} secures your data with enterprise-grade encryption</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel */}
      <div className={`flex-1 flex flex-col bg-white ${rightPanelWidth}`}>
        {/* Back button */}
        <div className="px-6 py-4">
          <Link 
            to="/" 
            className="inline-flex items-center text-sm text-gray-600 hover:text-primary-600 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-1.5" />
            Back to home
          </Link>
        </div>

        {/* Form content - centered vertically and horizontally */}
        <div className="flex-1 flex items-center justify-center px-6 pb-8">
          <div className="w-full max-w-5xl">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;